import lightGallery from 'lightgallery';

lightGallery(document.getElementById('product-gallery'), {
    speed: 500,
    download: false,
    showZoomInOutIcons: true,
    actualSize: false,
    zoomFromOrigin: false,
    prevHtml: '<svg class="icon icon--arrow icon--reverse"><use xlink:href="' +  wp.theme_path + '/assets/icons/icons.svg#arrow' + '"></use></svg>',
    nextHtml: '<svg class="icon icon--arrow"><use xlink:href="' + wp.theme_path + '/assets/icons/icons.svg#arrow' + '"></use></svg>',
});
